<template>
  <div class="analysis-ranking-page">
    <!--    城市选择    -->
    <citySelect class="city-select" serviceProvider="2" @chioce="chioceCity"></citySelect>
    <!--      时间选择      -->
    <timeSelect class="time" switch-icon @screen="screen"></timeSelect>

    <!--    数据表格    -->

    <table class="rank-data-table">
      <tr class="rank-tr-head">
        <th v-for="th in arrTableColumn" :key="th.title">
          {{ th.title }}
        </th>
      </tr>
      <tr class="rank-tr-body" v-for="(item, index) in arrServiceRankingList" :key="index" @click="toCompany(item.company_id)">
        <td v-for="{ key } in arrTableColumn" :key="key">
          {{ key === "order" ? index + 1 : item[key] }}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import timeSelect from "@/components/timeSelect/index";
import citySelect from "@/page/service/components/cityselect";
import { mapState } from "vuex";
import oStorage from '@/libsV2/storage.js';
import { getEarthRank } from "@/js/service";
import {fetchVerifyAuthForB} from '@/libsV2/havc.js';
export default {
  name: "ranking",
  data() {
    return {
      nPage:0,
      nAreaId: "", //城市id
      nProviderId:"",//服务商下拉ID
      nCityId:"",//城市下拉id
      nOrderId: "",
      sStartTime: "开始时间", //开始时间
      sEndTime: "结束时间", //结束时间
      // 表格栏
      arrTableColumn: [
        {
          title: "排序",
          key: "order",
        },
        {
          title: "服务商名称",
          key: "company_name",
        },
        {
          title: "完工项目",
          key: "contract_num",
        },
        {
          title: "项目合格评分",
          key: "service_score",
        },
        // {
        //   title: "用户满意评分",
        //   key: "customer_score",
        // },
        // {
        //   title: "综合服务评分",
        //   key: "composite_score",
        // },
      ],
    };
  },
  components: {
    timeSelect,
    citySelect,
  },
  mounted() {
        fetchVerifyAuthForB(()=>{
            // this.getRank()
        })
    // $init(() => {
    //   this.$store.commit("loadSwitch", true);
    //   Promise.all([this.getRank()]).then((res) => {
    //   });
    // });
  },
  computed: {
    ...mapState({
      // 服务商能力排名数据
      arrServiceRankingList: (state) => state.serviceCustomerScoring.arrServiceRankingList,
    }),
  },
  methods: {
    chioceCity(e) {
        // 判断是否是清除
        if(e.sClearType){
            if(e.sClearType=='DQ'){
                this.nProviderId=''
                this.nCityId=''
                this.nAreaId=''
            }else if(e.sClearType=='BSC'){
                this.nProviderId=''
                if(e.clearCity){
                    this.nCityId=''
                }
            }else if(e.sClearType=='CS'){
                this.nCityId=''
                if(e.clearSrevice){
                    this.nProviderId=''
                }
            }
            this.getRank(this.sStartTime === "开始时间" ? "" : this.sStartTime+" 00:00:00", this.sEndTime === "结束时间" ? "" : this.sEndTime+" 23:59:59", this.nOrderId, this.nAreaId,this.nProviderId,this.nCityId);
            return
        }
      //   选择城市
      if(e.third_uuid){
          this.nProviderId=e.third_uuid
           this.getRank(this.sStartTime === "开始时间" ? "" : this.sStartTime+" 00:00:00", this.sEndTime === "结束时间" ? "" : this.sEndTime+" 23:59:59", this.nOrderId, this.nAreaId,this.nProviderId,this.nCityId);
      }else if(e.id){
        this.nCityId=e.id
          if(e.isClearCompany){
              this.nProviderId=''
          }
           this.getRank(this.sStartTime === "开始时间" ? "" : this.sStartTime+" 00:00:00", this.sEndTime === "结束时间" ? "" : this.sEndTime+" 23:59:59", this.nOrderId, this.nAreaId,this.nProviderId,this.nCityId);
      }else{
        this.nAreaId=e
          this.nProviderId=''
          this.nCityId=''
            this.getRank(this.sStartTime === "开始时间" ? "" : this.sStartTime+" 00:00:00", this.sEndTime === "结束时间" ? "" : this.sEndTime+" 23:59:59", this.nOrderId, this.nAreaId,this.nProviderId,this.nCityId);
      }

    },
    // 获取表格数据-开始时间,结束时间,排序,大区
    getRank(startTime, endTime, nOrder, sArea,providerId,cityId) {
        this.$store.commit("loadSwitch", true);
      getEarthRank({ start_time: startTime, end_time: endTime, sort: nOrder, area_id: sArea,company_id:providerId,city_id:cityId,page:this.nPage,limit:100 }).then((res) => {
        // console.log("表格数据", res.data.data.result);
        this.$store.commit("editServeRank", res.data.data.result);
        this.$store.commit("loadSwitch", false);
      });
    },
    // 跳转公司
    toCompany(id) {
      // 将服务商id存储到vuex
      this.$store.commit("editCompanyId", id);
      this.$router.push({ path: "/hvac/agentscore/score" });
    //   localStorage.setItem('companyId', id);
      oStorage.setStorage('companyId', id);
      // console.log('12')
    },
    // 按条件筛选
    screen(e) {
      // console.log(e);
      this.nOrderId = e.nOrderId;
      this.sStartTime = e.sStartTime;
      this.sEndTime = e.sEndTime;
        this.getRank(this.sStartTime === "开始时间" ? "" : this.sStartTime+" 00:00:00", this.sEndTime === "结束时间" ? "" : this.sEndTime+" 23:59:59", this.nOrderId, this.nAreaId,this.nProviderId,this.nCityId);
    },
  },
};
</script>

<style scoped lang="scss">
.analysis-ranking-page {
  margin: 24px 0 36px;
  background: #ffffff;
  border-radius: $commonRadius;
  padding: 30px 24px;
  .time{
      position: relative;
      z-index: 10;
  }

  .city-select {
    margin-bottom: 24px;
  }
    .rank-data-table{
        width: 100%;
    }

  .rank-data-table {
    th,
    td {
      text-align: center;
      vertical-align: middle;
    }

    .rank-tr-head {
        width: 100%;
      color: $deepGreen;
      font-size: $smallSize;
      text-align: center;
      height: 130px;
      border-bottom: 1px solid #f1f1f1;

      th:nth-child(1) {
        //width: 80px;
          width: 16%;
        text-align: left;
      }

      th:nth-child(2) {
        //width: 146px;
          width:42.8%;
      }

      th:nth-child(3) {
        //width: 90px;
          width:17%;
        padding: 0 10px 0 32px;
      }

      th:nth-child(4),
      th:nth-child(5) {
        //width: 116px;
          width:24%;
        padding: 0 10px;
      }
    }

    .rank-tr-body {
      height: 118px;
      background: linear-gradient(to right, rgba(#f1f1f1, 1) 50%, transparent 50%) repeat-x left bottom / 16px 2px;

      td:nth-child(1) {
          width: 16%;
        text-align: left;
      }
        td:nth-child(2) {
            width:42.8%;
        }
        td:nth-child(3) {
            width:17%;
        }
        td:nth-child(4) {
            width:24%;
        }

      td:last-child {
        color: $deepGreen;
        position: relative;

        &::before {
          width: 22px;
          height: 22px;
          content: "";
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          background: url("~@/assets/images/project-detail/table-icon.png") no-repeat center/cover;
        }
      }
    }
  }
}
</style>
